import { Button as o } from "./button.js";
import { ButtonContent as n } from "./button-content/button-content.js";
import { ButtonIcon as r } from "./button-icon/button-icon.js";
const t = o;
t.Content = n;
t.Icon = r;
export {
  t as Button
};
